import "normalize.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client"; // 👈 usa o novo createRoot
import "wicg-inert";
import AppCore from "./core";
import "./index.scss";
import "react-toastify/dist/ReactToastify.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Substitui o ReactDOM.render
const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <StrictMode>
    <AppCore />
  </StrictMode>
);

// service worker continua igual
serviceWorkerRegistration.register({
  onUpdate: (registration: any) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event: any) => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
